// Gallery section
export const IMAGE_SIZES_MOBILE = [
    { w: 360, h: 270 },
    { w: 640, h: 480 },
    { w: 768, h: 576 },
    { w: 1024, h: 768 },
];
export const IMAGE_SIZES = [
    ...IMAGE_SIZES_MOBILE,
    { w: 1280, h: 960 },
    { w: 1536, h: 1152 },
    { w: 1920, h: 1440 },
];
export const MASONRY_IMAGE_SIZES = [
    { minW: 0, maxW: 360, w: 360, h: 240 },
    { minW: 361, maxW: 600, w: 600, h: 399 },
    { minW: 601, maxW: 768, w: 524, h: 349 },
    { minW: 769, maxW: 1024, w: 716, h: 477 },
    { minW: 1025, maxW: 1280, w: 738, h: 492 },
    { minW: 1281, maxW: false, w: 738, h: 492 },
];
export const MASONRY_IMAGE_SIZES_HALF = [
    { minW: 0, maxW: 360, w: 176, h: 117 },
    { minW: 361, maxW: 600, w: 296, h: 196 },
    { minW: 601, maxW: 768, w: 258, h: 172 },
    { minW: 769, maxW: 1024, w: 354, h: 236 },
    { minW: 1025, maxW: 1280, w: 365, h: 243 },
    { minW: 1281, maxW: false, w: 365, h: 243 },
];
export const IMAGE_SIZE_XXL = {
    w: 1920,
    h: 1440,
};
export const DESKTOP_PREVIEW_LARGE = { w: 768, h: 560 };
export const DESKTOP_PREVIEW_MEDIUM = { w: 360, h: 280 };
